'use client';

import { CatButton } from 'components/blocks-components';
import styles from './style.module.scss';
import { bannerTexts } from '../../constants';
import {
  getSessionStorage,
  removeSessionStorage
} from '@cat-ecom/common/utils/storageUtils';
import { IS_GUEST } from 'constants/storageConstants';
import { Conditional } from '@cat-ecom/pcc-components';
import { USER_RESET_SESSION } from 'constants/endpoints.api';
import { Method } from 'constants/enums';

export const GuestBanner = () => {
  const isGuest = JSON.parse(getSessionStorage(IS_GUEST));
  const { TRANSACT_AS_GUEST, DISCONNECT_BTN } = bannerTexts;

  const disconnect = async () => {
    const response = await fetch(USER_RESET_SESSION, {
      method: Method.GET
    });
    const data = await response.json();
    removeSessionStorage(IS_GUEST);
    window.location.href = data.url;
  };

  const redirectToCSRHome = () => {
    disconnect();
  };

  return (
    <Conditional test={isGuest}>
      <header className={styles['header']}>
        <div className="d-flex justify-content-center align-items-center">
          <p className="mt-2 mb-2">{`${TRANSACT_AS_GUEST}`}</p>
          <CatButton
            className="p-2"
            variant="contrast"
            inverted
            onClick={redirectToCSRHome}
          >
            {DISCONNECT_BTN}
          </CatButton>
        </div>
      </header>
    </Conditional>
  );
};
